<template>
  <div id="app" class="w-100">
    <div id="nv" v-if="!isComingSoon">
      <b-navbar id="n121" @click="addPadding()" type="light" variant="faded" fixed="top">
        <b-navbar-toggle id="n122" target="nav-collapse"></b-navbar-toggle>
        <b-collapse id="nav-collapse" class="grey navbar setFixedSize" is-nav>
          <b-navbar-nav id="n123" class="left-allign-in-nav scale">
            <a class="navbar-brand scale logoo" href="/">
              <img
                src="../public/img/logos/fulllogo2.png"
                class="d-inline-block align-top scale"
                alt
              />
              <img
                src="../public/img/logos/vortex_name.png"
                class="d-inline-block align-top paddi scale"
                id="vortexNameImage"
                alt
              />
            </a>
          </b-navbar-nav>

          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto scale">
            <b-navbar-nav id="right_nav" right>
              <div id="nav2" class="navbar_button_div border_up">
                <b-nav-item class="allign_in_navbar">
                  <router-link @click.native="setActive(2)" tag="b-nav-item" to="/about_us">About</router-link>
                </b-nav-item>
              </div>

              <div id="nav3" class="navbar_button_div border_up">
                <b-nav-item class="allign_in_navbar">
                  <router-link
                    @click.native="setActive(3)"
                    tag="b-nav-item"
                    to="/commercial"
                  >Commercial</router-link>
                </b-nav-item>
              </div>

              <div id="nav5" class="navbar_button_div border_up">
                <b-nav-item class="allign_in_navbar">
                  <router-link @click.native="setActive(5)" tag="b-nav-item" to="/store">Store</router-link>
                </b-nav-item>
              </div>

              <div @click="redirectToHome()" class="dspr">
                <b-nav-item class="allign_in_navbar">
                  <a class="navbar-brand scale logooo" href="/">
                    <img
                      src="../public/img/logos/fulllogo2.png"
                      class="d-inline-block align-top scale"
                      alt
                    />
                  </a>
                </b-nav-item>
              </div>
              <div id="nav4" class="navbar_button_div border_up">
                <b-nav-item class="allign_in_navbar">
                  <router-link @click.native="setActive(4)" tag="b-nav-item" to="/academy">Academy</router-link>
                </b-nav-item>
              </div>

              <div id="nav6" class="navbar_button_div border_up">
                <b-nav-item class="allign_in_navbar">
                  <router-link
                    id="comp_66"
                    @click.native="setActive(6)"
                    tag="b-nav-item"
                    to="/team"
                  >Team</router-link>
                </b-nav-item>
              </div>

              <div id="nav8" class="navbar_button_div border_up">
                <b-nav-item class="allign_in_navbar">
                  <router-link @click.native="setActive(8)" tag="b-nav-item" to="/auv">AUV</router-link>
                </b-nav-item>
              </div>

              <div id="nav7" class="navbar_button_div border_up">
                <b-nav-item class="allign_in_navbar">
                  <router-link
                    @click.native="setActive(7)"
                    tag="b-nav-item"
                    to="/contact_us"
                  >Contact</router-link>
                </b-nav-item>
              </div>
            </b-navbar-nav>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </div>
    <div id="show_when_nav_collaps" class="show_when_nav_collaps"></div>
    <div class="flying_gear fly_right_up" id="flying_gear1"></div>
    <div class="flying_gear fly_right_down" id="flying_gear2"></div>
    <div class="flying_gear fly_left_up" id="flying_gear3"></div>

    <router-view />

    <div class="sticky-container" v-if="!isComingSoon">
      <ul class="sticky">
        <li>
          <img
            @click="setActive(7)"
            width="32"
            height="32"
            title
            alt
            src="../public/img/icons/contact_us.png"
          />
          <p>
            <router-link to="/contact_us">Contact Us</router-link>
          </p>
        </li>
        <li>
          <img
            @click="setActive(2)"
            width="32"
            height="32"
            title
            alt
            src="../public/img/icons/about_us.png"
          />
          <p>
            <router-link to="/about_us">About Us</router-link>
          </p>
        </li>
      </ul>
    </div>
    <Footer v-if="!isComingSoon" />
  </div>
</template>

<script>
import { timeout } from "q";
import GearsSep from "./components/GearsSep.vue";
import Footer from "./components/Footer.vue";
import { setTimeout } from "timers";
export default {
  components: {
    GearsSep,
    Footer
  },
  data() {
    return {
      flag: true,
      windowWidth: 0,
      windowHeight: 0,
      auvPageFlag: false
    };
  },
  computed: {
    isComingSoon() {
      return this.$route.name === "ComingSoon";
    }
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    if (window.location.pathname === "/") {
      setTimeout(() => this.$router.push({ path: "/coming-soon" }), 2800);
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  mounted() {
    this.$nextTick(function() {
      window.addEventListener("resize", this.getWindowWidth);
      this.getWindowWidth();
    });
    var currentWidth = window.innerWidth;
    document.getElementById("flying_gear1").style.visibility = "hidden";
    document.getElementById("flying_gear2").style.visibility = "hidden";
    document.getElementById("flying_gear3").style.visibility = "hidden";
    var url = window.location.pathname;
    if (url === "/") {
      var deg = 0;
      this.doLoading(this, deg);
    }
    url = window.location.pathname;
    if (url === "/auv") this.auvPageFlag = true;
    var current = "";
    if (url === "/home") {
      current = "nav1";
      document.getElementById("nav-collapse").style.backgroundColor =
        "rgb(0,0,0,0)";
      document.getElementById("n121").style.backgroundColor =
        "rgb(242, 242, 242, 0)";
      document.getElementById("n122").style.backgroundColor = "rgb(0,0,0,0)";
      document.getElementById("n123").style.backgroundColor = "rgb(0,0,0,0)";
      document.getElementById("n121").style.color = "rgb(0,0,0) !important";
      document
        .getElementById("vortexNameImage")
        .setAttribute("src", "img/logos/vortex_name2.png");
    } else if (url === "/about_us") {
      current = "nav2";
    } else if (url === "/commercial") {
      current = "nav3";
    } else if (url === "/academy") {
      current = "nav4";
    } else if (url === "/store") {
      current = "nav5";
    } else if (url === "/team") {
      current = "nav6";
    } else if (url === "/contact_us") {
      current = "nav7";
    } else if (url === "/auv") {
      current = "nav8";
    }
    window.scrollTo(0, 0);
    if (current !== "" && current !== "nav1" && window.innerWidth > 530) {
      document.getElementById(current).style.borderTop = "5px solid #00264A";
      var i;
      for (i = 2; i < 9; i++) {
        if ("nav" + i === current) {
          continue;
        } else {
          document.getElementById("nav" + i).style.borderTop =
            "5px solid #dddddd";
        }
      }
    }
  },
  methods: {
    redirectToHome() {
      window.location = "/";
    },
    doFading() {
      document.getElementById("loader").classList.add("fadee");
      document.getElementById("loader").transform = "scale(8)";
    },
    doSlogan() {
      document.getElementById("l_s").style.visibility = "visible";
      document.getElementById("r_s").style.visibility = "visible";
      if (window.innerWidth > 550 && window.innerWidth < 800) {
        document.getElementById("l_s").style.transform = "translate(20%, 0)";
        setTimeout(() => {
          var i;
          this.doRotation(this, 0);
          setTimeout(
            () =>
              (document.getElementById("r_s").style.transform =
                "translate(-20%, 0)"),
            1300
          );
        }, 700);
      } else if (window.innerWidth > 550) {
        document.getElementById("l_s").style.transform = "translate(95%, 0)";
        setTimeout(() => {
          var i;
          this.doRotation(this, 0);
          setTimeout(
            () =>
              (document.getElementById("r_s").style.transform =
                "translate(-95%, 0)"),
            1300
          );
        }, 700);
      } else if (window.innerWidth < 400) {
        document.getElementById("l_s").style.transform = "translate(60%, 0)";
        setTimeout(() => {
          var i;
          this.doRotation(this, 0);
          setTimeout(
            () =>
              (document.getElementById("r_s").style.transform =
                "translate(-60%, 0)"),
            1300
          );
        }, 700);
      } else {
        document.getElementById("l_s").style.transform = "translate(67%, 0)";
        setTimeout(() => {
          var i;
          this.doRotation(this, 0);
          setTimeout(
            () =>
              (document.getElementById("r_s").style.transform =
                "translate(-67%, 0)"),
            1300
          );
        }, 700);
      }
      window.scrollTo(0, 0);
    },
    doRotation(that, deg) {
      if (deg < 580) {
        document.getElementById("m_s").style.webkitTransform =
          "rotate(" + (deg % 360) * 2 + "deg)";
        document.getElementById("m_s").style.transform =
          "rotate(" + (deg % 360) * 2 + "deg)";
        setTimeout(function() {
          that.doRotation(that, deg + 2);
        });
      }
    },
    doLoading(that, deg) {
      if (deg < 740) {
        document.getElementById("loader").style.webkitTransform =
          "rotate(" + (deg % 360) + "deg)";
        document.getElementById("loader").style.transform =
          "rotate(" + (deg % 360) + "deg)";
        setTimeout(function() {
          that.doLoading(that, deg + 2);
        }, 3);
      } else {
        this.doFading();
      }
    },
    scrollToTop() {
      document.documentElement.style.scrollBehavior = "smooth";
      window.scrollTo(0, 0);
    },
    handleScroll(event) {
      var scrollTop = window.scrollY;
      var url = window.location.pathname;

      if (scrollTop > 80) {
        document.getElementById("nav-collapse").style.height = "60px";
        document.getElementById("nav-collapse").style.backgroundColor =
          "#FFFFFF";
        document.getElementById("n121").style.backgroundColor = "#FFFFFF";
        document.getElementById("n122").style.backgroundColor = "#FFFFFF";
        document.getElementById("n123").style.backgroundColor = "#FFFFFF";
        document.getElementById("n121").style.boxShadow =
          "0px 0px 5px 1px #327be6";
        var tabs = document.getElementById("right_nav").querySelectorAll("a");
        for (var i = 0; i < tabs.length; i++) {
          tabs[i].style.color = "#00264a";
        }
        document
          .getElementById("vortexNameImage")
          .setAttribute("src", "img/logos/vortex_name.png");
      } else {
        document.getElementById("nav-collapse").style.height = "80px";
        document.getElementById("n121").style.boxShadow =
          "0px 0px 0px 0px #000000";
        if (url === "/home" || url === "/commercial" || url === "/auv") {
          this.adjustNavbarStyleForVideos();
        } else {
          document.getElementById("nav-collapse").style.backgroundColor =
            "#F2F2F2";
          document.getElementById("n121").style.backgroundColor = "#F2F2F2";
          document.getElementById("n122").style.backgroundColor = "#F2F2F2";
          document.getElementById("n123").style.backgroundColor = "#F2F2F2";
        }
      }
      if (
        scrollTop + 900 > document.getElementById("app").scrollHeight &&
        window.innerWidth < 550
      ) {
      }

      if (scrollTop > 725) {
        document.getElementById("flying_gear1").style.visibility = "visible";
        document.getElementById("flying_gear2").style.visibility = "visible";
        document.getElementById("flying_gear3").style.visibility = "visible";
      } else {
        document.getElementById("flying_gear1").style.visibility = "hidden";
        document.getElementById("flying_gear2").style.visibility = "hidden";
        document.getElementById("flying_gear3").style.visibility = "hidden";
      }
      scrollTop = window.scrollY / 2;
      var rotateVal = scrollTop % 360;
      var gears = [
        "gear1",
        "gear2",
        "gear3",
        "gear4",
        "gear5",
        "gear7",
        "gear8",
        "gear9",
        "flying_gear1",
        "flying_gear2",
        "flying_gear3"
      ];
      var i;
      for (i = 0; i < gears.length; i++) {
        if (document.getElementById(gears[i])) {
          document.getElementById(gears[i]).style.webkitTransform =
            "rotate(" + rotateVal + "deg)";
          document.getElementById(gears[i]).style.transform =
            "rotate(" + rotateVal + "deg)";
        }
      }
    },
    adjustNavbarStyleForVideos() {
      document.getElementById("nav-collapse").style.backgroundColor =
        "rgb(0,0,0,0)";
      document.getElementById("n121").style.backgroundColor =
        "rgb(242, 242, 242, 0)";
      document.getElementById("n122").style.backgroundColor = "rgb(0,0,0,0)";
      document.getElementById("n123").style.backgroundColor = "rgb(0,0,0,0)";
      var tabs = document.getElementById("right_nav").querySelectorAll("a");
      for (var i = 0; i < tabs.length; i++) {
        tabs[i].style.color = "white";
      }
      document
        .getElementById("vortexNameImage")
        .setAttribute("src", "img/logos/vortex_name2.png");
    },
    setActive(id) {
      document.documentElement.style.scrollBehavior = "auto";
      setTimeout(
        () => (document.documentElement.style.scrollBehavior = "smooth"),
        1000
      );
      document.getElementById("nav" + id).style.borderTop = "5px solid #00264A";
      var i;
      for (i = 2; i < 9; i++) {
        if ("nav" + i === "nav" + id) {
          continue;
        } else {
          document.getElementById("nav" + i).style.borderTop =
            "5px solid #dddddd";
        }
      }
      window.scrollTo(0, 0);
    },
    addPadding() {
      if (this.flag) {
        document.getElementById("show_when_nav_collaps").style.display =
          "block";
        this.flag = false;
      } else {
        this.flag = true;
      }
    },
    show_popup() {
      document.getElementById("nav-collapse").classList.remove("setFixedSize");
      document.getElementById("nav-collapse").style.height = "160px";
    },
    hide_popup() {
      document.getElementById("nav-collapse").style.height = "80px";
      document.getElementById("nav-collapse").classList.add("setFixedSize");
    },
    getWindowWidth(event) {
      this.windowWidth = document.documentElement.clientWidth;
      document.getElementById("comp_66").scrollIntoView();
      document.getElementById("nav-collapse").scrollLeft -= 30;
    },
    beforeDestroy() {
      window.removeEventListener("resize", this.getWindowWidth);
      window.removeEventListener("resize", this.getWindowHeight);
    }
  }
};
</script>

<style lang="scss">
body {
  overflow-x: hidden !important;
  scroll-behavior: smooth;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  a {
    text-decoration: none;
  }
}
.main_header {
  background-color: #f2f2f2;
  width: 100%;
  text-align: center;
  padding-top: 140px;
}

.show_when_nav_collaps {
  width: 100%;
  height: 90px;
  background-color: #f2f2f2;
  display: none;
}
#app,
#nv,
#n121 {
  -webkit-animation: fadein 1.5s; /* Safari, Chrome and Opera > 12.1 */
  -moz-animation: fadein 1.5s; /* Firefox < 16 */
  -ms-animation: fadein 1s; /* Internet Explorer */
  -o-animation: fadein 1s; /* Opera < 12.1 */
  animation: fadein 1.5s;
}
.shift_up {
  margin-top: -10% !important;
}
.sticky-container {
  /*background-color: #333;*/
  padding: 0px;
  margin: 0px;
  position: fixed;
  right: -119px;
  bottom: 25%;
  width: 200px;
  visibility: hidden;
  z-index: 9999;
}

/* style p when hover li */
.sticky-first li:hover p {
  float: right;
}
.sticky li {
  list-style-type: none;
  background-color: #00264a;
  border-radius: 18px 0px 0px 18px;
  color: white;
  height: 43px;
  opacity: 0.7;
  padding: 0px;
  margin: 20px 0px 1px 0px;
  -webkit-transition: all 0.25s ease-in-out;
  -moz-transition: all 0.25s ease-in-out;
  -o-transition: all 0.25s ease-in-out;
  transition: all 0.25s ease-in-out;
  cursor: pointer;
  a {
    color: white;
  }
}

.sticky li:hover {
  //margin-left: -115px;
  opacity: 1;
  -webkit-transform: translateX(-115px);
  -moz-transform: translateX(-115px);
  -o-transform: translateX(-115px);
  -ms-transform: translateX(-115px);
  transform: translateX(-115px);
  background-color: #00264a;
}

.sticky li img {
  float: left;
  margin: 5px 5px;
  margin-right: 10px;
}

.sticky li p {
  padding: 0px;
  padding-right: 20px;
  margin: auto;
  line-height: 43px;
}

.navbar-light .navbar-nav .nav-link:hover,
.navbar-light .navbar-nav .nav-link:focus {
  color: rgba(0, 0, 0, 1);
}
#right_nav a {
  font-size: 17px;
  font-weight: bold;
}
.setFixedSize {
  height: 80px;
}
.dspr {
  display: none;
}
.navbar {
  -webkit-transition: height 0.5s, line-height 0.5s; /* Safari */
  transition: height 0.5s, line-height 0.5s;
  background-color: #f2f2f2;
  a {
    font-weight: light;
    color: rgba(54, 97, 73, 0.979);
    font-weight: light;
    &.router-link-exact-active {
      color: rgb(153, 14, 14);
      font-weight: bold;
    }
  }
}
.top-contianer {
  -webkit-animation: fadein 0.5s; /* Safari, Chrome and Opera > 12.1 */
  -moz-animation: fadein 0.5s; /* Firefox < 16 */
  -ms-animation: fadein 0.5s; /* Internet Explorer */
  -o-animation: fadein 0.5s; /* Opera < 12.1 */
  animation: fadein 0.5s;
  overflow: hidden;
  background: #ffffff center no-repeat;
}
.nav-pills .nav-link {
  top: 30%;
  position: relative;
}
.logoo {
  visibility: visible;
  transition: 0.3s all ease-in-out;
}
.logoo:hover {
  transform: scale(1.05);
}
.drop_down_rovs {
  z-index: 9999;
}
.logooo {
  margin-top: 0%;
  visibility: hidden;
}
.grey {
  background-color: #f2f2f2;
}

.paddi {
  margin: 2px 20px 0px;
}
.border_up {
  border-top: 5px solid #dddddd;
}
.border_up_active {
  border-top: 5px solid #00264a;
}
a.next {
  top: -100px !important;
  line-height: 250px !important;
}
a.prev {
  top: -100px !important;
  line-height: 250px !important;
}
#nav4 a {
  left: -2% !important;
  position: relative !important;
}
#nav5 a {
  left: 2% !important;
  position: relative !important;
}
#nav3 a {
  left: -8% !important;
  position: relative !important;
}
.scale {
  position: relative;
  height: 110%;
  width: auto;
}
// .card-img-top {
//   /* width: 80% !important;
//     left: 50%;
//     position: relative;
//     transform: translate(-50%, 0%);*/
// }
.navbar-nav {
  flex-direction: row !important;
}
.navbar-nav .nav-link {
  padding-right: 0.5rem;
  padding-left: 0.2rem !important;
}
.navbar_button_div {
  margin: 0px 6px 0px;
  position: relative;
  top: -23%;
  height: 80%;
  width: 80px;
  font-family: Arial, Helvetica, sans-serif;
  font-weight: 1px;
  font-size: 17px;
  font-weight: lighter;
}
.allign_in_navbar {
  position: relative;
  top: 15%;
}
.left-allign-in-nav {
  position: relative;
  left: 11%;
  top: -10%;
}

@keyframes fadeOut {
  from {
    opacity: 1;
    -webkit-transform: rotate(0deg) scale(1); /* Chrome 4+, Op 15+, Saf 3.1, iOS Saf 3.2+ */
    -moz-transform: rotate(0deg) scale(1); /* Fx 3.5-15 */
    -ms-transform: rotate(0deg) scale(1); /* IE 9 */
    -o-transform: rotate(0deg) scale(1); /* Op 10.5-12 */
    transform: rotate(0deg) scale(1);
  }
  to {
    opacity: 0.2;
    -webkit-transform: rotate(359deg) scale(20); /* Chrome 4+, Op 15+, Saf 3.1, iOS Saf 3.2+ */
    -moz-transform: rotate(359deg) scale(12); /* Fx 3.5-15 */
    -ms-transform: rotate(359deg) scale(12); /* IE 9 */
    -o-transform: rotate(359deg) scale(12); /* Op 10.5-12 */
    transform: rotate(359deg) scale(12);
  }
}

/* Firefox < 16 */
@-moz-keyframes fadeOut {
  from {
    opacity: 1;
    -moz-transform: rotate(0deg) scale(1); /* Fx 3.5-15 */
    transform: rotate(0deg) scale(1);
  }
  to {
    opacity: 0.2;
    -moz-transform: rotate(359deg) scale(20); /* Fx 3.5-15 */
    transform: rotate(359deg) scale(20);
  }
}

/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes fadeOut {
  from {
    opacity: 1;
    -webkit-transform: rotate(0deg) scale(1); /* Chrome 4+, Op 15+, Saf 3.1, iOS Saf 3.2+ */
    -o-transform: rotate(0deg) scale(1); /* Op 10.5-12 */
    transform: rotate(0deg) scale(1);
  }
  to {
    opacity: 0.2;
    -webkit-transform: rotate(359deg) scale(12); /* Chrome 4+, Op 15+, Saf 3.1, iOS Saf 3.2+ */
    -o-transform: rotate(359deg) scale(12); /* Op 10.5-12 */
    transform: rotate(359deg) scale(12);
  }
}

/* Internet Explorer */
@-ms-keyframes fadeOut {
  from {
    opacity: 1;
    -ms-transform: rotate(0deg) scale(1); /* IE 9 */
    transform: rotate(0deg) scale(1);
  }
  to {
    opacity: 0;
    -ms-transform: rotate(359deg) scale(12); /* IE 9 */
    transform: rotate(359deg) scale(12);
  }
}

@media screen and (max-width: 992px) {
  .dspr {
    display: block;
    margin-top: -4%;
  }
  .scale {
    height: 50px;
  }
  .logoo {
    visibility: hidden;
  }
  .navbar-nav {
    position: absolute;
    margin-top: -7px;
    right: 0%;
    width: 100% !important;
    display: flex;
    justify-content: center;
  }
  .logooo {
    visibility: visible;
    width: 100%;
    left: 0%;
  }
  #nav6 {
    display: none;
  }
}

@media screen and (max-width: 770px) {
  .navbar_button_div {
    width: 70px;
  }
  .left_slogan h1 {
    font-size: 1.5rem !important;
  }
  #nav3 a {
    left: -12% !important;
    position: relative !important;
  }
  .right_slogan h1 {
    font-size: 1.6rem !important;
  }
  .info-img {
    max-width: 320px;
    position: relative;
    left: 50%;
    transform: translate(-50%, 0);
  }
  .info-text {
    text-align: center;
  }
  .info-card {
    margin-left: 0% !important;
  }
  #containerOfNews .info-card {
    left: 50%;
    transform: translate(-50%, 0);
  }
}

@media screen and (max-width: 550px) {
  #right_nav a {
    font-size: 17px;
    font-weight: normal;
  }
  .sticky-container {
    visibility: visible;
  }
  #nav3 a {
    left: -22% !important;
    position: relative !important;
  }
  #nav6 a {
    left: 5% !important;
    position: relative !important;
  }
  .border_up {
    border-top: 0px solid #dddddd !important;
  }
  .navbar_button_div {
    font-size: 17px;
    top: 0%;
  }
  .info-img {
    max-width: 220px;
  }
  .dspr {
    top: 20%;
  }
  #rov_card {
    max-width: 16rem !important;
  }
  .section-divider:before {
    top: -1rem !important;
    left: calc(50% - 1rem);
  }
  .section-divider1:before {
    top: -1rem !important;
    left: calc(50% - 1rem);
  }
  #m_s {
    position: relative;
    top: -10%;
  }
  .left_slogan h1 {
    font-size: 0.9rem !important;
  }
  .right_slogan h1 {
    font-size: 0.9rem !important;
  }
  .slogan_logo {
    width: 30px;
    height: 30px;
  }
  #team_row {
    display: block !important;
    margin-left: 0%;
    /*kanet -30*/
  }

  #team_rov {
    display: block !important;
    margin-left: 0%;
    /*kanet -22*/
  }
  #rovs_col {
    flex-basis: auto !important;
  }
  .grey_strip {
    height: 100px;
    width: 100%;
  }
  #nav-collapse {
    overflow-x: hidden;
    overflow-y: hidden;
  }
  .navbar-nav {
    justify-content: center;
    height: 75px;
    margin-top: 10px;
  }
  .show_when_nav_collaps {
    width: 100%;
  }
  .stick_right {
    right: 0%;
  }
  .stick_left {
    left: -55% !important;
  }
  .vlarge {
    visibility: hidden;
  }
  #nav2 {
    display: none;
  }
  #nav7 {
    display: none;
  }

  .carousel_container {
    padding-top: 0px !important;
  }
  #gear7[data-v-1849982a] {
    left: 0%;
  }

  #flying_gear1 {
    right: -5px;
  }
  #flying_gear2 {
    right: -5px;
  }
  #flying_gear3 {
    left: -5px;
  }
  .navbar_button_div {
    margin: 0px 0px 0px;
  }
  .navbar-nav {
    margin-top: -2px;
  }
}
@media screen and (max-width: 430px) {
  #nav6 a {
    left: -2% !important;
    position: relative !important;
  }
  #nav3 a {
    left: -12% !important;
    position: relative !important;
  }
  #nav5 a {
    left: 16% !important;
    position: relative !important;
  }
  #nav4 a {
    left: -10% !important;
    position: relative !important;
  }
  .tips {
    width: 100%;
  }
}
@media screen and (max-width: 400px) {
  .navbar_button_div {
    font-size: 15px;
  }
  #nav3 a {
    left: -5.5% !important;
    font-size: 16px;
    position: relative !important;
  }
  #nav5 a {
    font-size: 16px;
    left: 15% !important;
  }
  #nav6 a {
    font-size: 16px;
  }
  #nav4 a {
    font-size: 16px;
  }
  .left_slogan h1 {
    font-size: 0.75rem !important;
  }
  .right_slogan h1 {
    font-size: 0.75rem !important;
  }
}
@media screen and (max-width: 350px) {
  .navbar-nav {
    justify-content: left;
  }
  #nav-collapse {
    -webkit-overflow-scrolling: touch;
    overflow-x: scroll !important;
    overflow-y: hidden;
  }
  .left_slogan h1 {
    font-size: 0.6rem !important;
  }
  .right_slogan h1 {
    font-size: 0.6rem !important;
  }
}
</style>
